var exports = {
  "k": "x61f99309--7b4515--container",
};

module.exports = exports;
